import { app } from '../app';

class RoleResource {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getAllCompanyUsersByRole(companyId, role) {
        const url = `app/rest/v2/company/${companyId}/roles/${role}`;
        return this.$http.get(url).then(({data}) => data);
    }

    getAllCompanyUsersWithRole(companyId) {
        const url = `app/rest/v2/company/${companyId}/roles`;
        return this.$http.get(url).then(({data}) => data).then(users => users.map(sanitize));

        function sanitize(user) {
            return {
                ...user,
                applicationIds: user.applicationIds || [],
                applicationTypeIds: user.applicationTypeIds || [],
                groupIds: user.groupIds || [],
            };
        }
    }

    addNewRole(companyId, companyUserDTO) {
        const url = `app/rest/v2/company/${companyId}/roles`;
        return this.$http.post(url, companyUserDTO).then(({data}) => data);
    }

    removeRoleInCompany(companyId, companyUserId, params) {
        const url = `app/rest/v2/company/${companyId}/roles/${companyUserId}`;
        return this.$http.delete(url, {params}).then(({data}) => data);
    }

    unblockUserInCompany(companyId, companyUserId, params) {
        const url = `app/rest/v2/company/${companyId}/roles/${companyUserId}`;
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    getApplicationsAndTypes(companyId) {
        const url = `app/rest/v2/company/${companyId}/roles`;
        const params = {role: 'application', type: 'data'};
        return this.$http.get(url, {params}).then(({data}) => data);
    }

    editApplicationAdminRole(companyId, companyUserDTO) {
        const url = `app/rest/v2/company/${companyId}/roles`;
        const params = {role: 'application', action: 'edit'};
        return this.$http.put(url, companyUserDTO, {params}).then(({data}) => data);
    }

    editOrganizationAdminRole(companyId, companyUserDTO) {
        const url = `app/rest/v2/company/${companyId}/roles`;
        const params = {role: 'organization', action: 'edit'};
        return this.$http.put(url, companyUserDTO, {params}).then(({data}) => data);
    }
}

app.service('RoleResource', RoleResource);



// WEBPACK FOOTER //
// ./src/portal/rest/RoleResource.js